import React, { useEffect, useMemo, useState } from 'react';
import { Button, Card, FormControl, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faRedo } from '@fortawesome/free-solid-svg-icons';
import { saveAs } from 'file-saver';
import useToaster from '../../actions/useToaster';
import * as http from '../../http';

function LogsPage() {
  const toaster = useToaster();
  const [logLines, setLogLines] = useState<string[]>([]);
  const [logsList, setLogsList] = useState<{ currents: string[]; oldServer: string[]; oldStorage: string[] }>({
    currents: [],
    oldServer: [],
    oldStorage: [],
  });
  const [lineCount, setLineCount] = useState(50);
  const [showLogsModal, setShowLogsModal] = useState(false);
  const formattedLogs = useMemo(() => logLines.slice(logLines.length - lineCount), [logLines, lineCount]);

  useEffect(() => {
    getLogs(100);
    getLogsList();
  }, []);

  function getLogs(lines: number) {
    http
      .get<string>(`/rest/react/logs/current?lines=${lines}`)
      .then(json => {
        const foundLines = json ? json.split('\n') : [];
        foundLines.pop();
        setLogLines(foundLines);
      })
      .catch(() => {
        toaster.error('Error loading current logs');
      });
  }

  function getLogsList() {
    http
      .get<{ currents: string[]; oldServer: string[]; oldStorage: string[] }>(`/rest/react/logs`)
      .then(setLogsList)
      .catch(() => {
        toaster.error('Error loading logs list');
      });
  }

  return (
    <Card className="page-panel-common">
      <Card.Body>
        <h3>Logs</h3>
        <div className="logs-page">
          <div>Presented lines: (max 100 - min 1)</div>
          <FormControl
            size="sm"
            type="number"
            max="100"
            min="1"
            value={lineCount}
            style={{ width: '38px', textAlign: 'center' }}
            onChange={e => {
              const tempLineCount = parseInt(e.target.value, 10);
              if (tempLineCount >= 100) {
                setLineCount(100);
              } else if (tempLineCount <= 1) {
                setLineCount(1);
              } else {
                setLineCount(tempLineCount);
              }
            }}
          />
          <Button size="sm" onClick={() => getLogs(100)}>
            <FontAwesomeIcon style={{ marginRight: '1em' }} icon={faRedo} />
            Refresh
          </Button>
          <Button size="sm" onClick={() => setShowLogsModal(true)}>
            <FontAwesomeIcon style={{ marginRight: '1em' }} icon={faDownload} />
            Download logs
          </Button>
        </div>
        <Card className="logs-panel">
          <LogsCard formattedLogs={formattedLogs} />
        </Card>
      </Card.Body>

      {showLogsModal && logsList && <DownloadLogsModal logsList={logsList} onClose={() => setShowLogsModal(false)} />}
    </Card>
  );
}

const LogsCard = ({ formattedLogs }) => (
  <Card.Body>
    {formattedLogs &&
      formattedLogs.length > 0 &&
      formattedLogs.map((log, index) => (
        <div key={index} className="log">
          {log}
        </div>
      ))}
  </Card.Body>
);

const DownloadLogsModal = ({ logsList, onClose }) => {
  return (
    <Modal show>
      <Modal.Header>
        <Modal.Title>Download logs</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="logs-container">
          <DownloadList logsList={logsList.currents} />
          <div className="separator"></div>
          <DownloadList logsList={logsList.oldServer} />
          <div className="separator"></div>
          <DownloadList logsList={logsList.oldStorage} />
        </div>
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} variant="outline-secondary" style={{ marginRight: '5px' }}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const DownloadList = ({ logsList }) => {
  const toaster = useToaster();

  function downloadLogs(fileName: string) {
    http
      .get<any>(`/rest/react/logs/download?fileName=${fileName}`, undefined, res => res.blob())
      .then(data => {
        const blob = new Blob([data], { type: 'application/octet-stream' });
        saveAs(blob, fileName);
      })
      .catch(error => {
        toaster.error('Error downloading log file');
      });
  }

  return (
    <React.Fragment>
      {logsList.length > 0 && (
        <div className="queue-table download-log-table">
          {logsList.map(fileName => (
            <div className="log-file-entry" key={fileName}>
              <div>{fileName}</div>
              <Button size="sm" onClick={() => downloadLogs(fileName)}>
                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '1em' }} />
                Download
              </Button>
            </div>
          ))}
        </div>
      )}
    </React.Fragment>
  );
};

export default LogsPage;
